import { Apollo } from 'apollo-angular';
import { PartnerInterface } from './definitions/partner-interface';
import { ErrorsInterface } from '../errors/errors-interface';
import { Observable } from 'rxjs';
import { DocumentNode } from 'graphql';
import { FetchResult } from '@apollo/client/core';
import { Injectable } from '@angular/core';

export interface PartnerDisableCustomTaskCompletedEmailingSubjectResponse {
  partner: {
    disableCustomTaskCompletedSubject: {
      output: PartnerInterface;
      errors: ErrorsInterface;
    };
  };
}

@Injectable()
export class PartnerDisableCustomTaskCompletedEmailingSubjectService {
  constructor(private apollo: Apollo) {}

  public disable(
    id: string,
    mutation: DocumentNode
  ): Observable<FetchResult<any>> {
    return this.apollo.mutate<PartnerDisableCustomTaskCompletedEmailingSubjectResponse>({
      mutation: mutation,
      variables: {
        id: id,
      },
    });
  }
}
